<template>
    <c-dialog ref="dialog" title="客户详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.customer_code" class="m-detail-tag flex-center-cross">
                <label>{{detailData.customer_name}}</label>
                <c-state :value="detailData.is_new_customer == '1' ? 1 : 2" tag></c-state>
            </div>
        </template>
        <module>
            <module-col tab-type="border-tab">
                <module-tab name="基础信息" enable-flex>
                    <div class="m-detail-box">
                        <c-title>客户资料</c-title>
                        <c-detail column="2">
                            <c-detail-item label="客户编号">
                                {{detailData.customer_code}}
                            </c-detail-item>
                            <c-detail-item label="客户名称">
                                {{detailData.customer_name}}
                            </c-detail-item>
                            <c-detail-item label="客户简称">
                                {{detailData.customer_short_name}}
                            </c-detail-item>
                            <c-detail-item label="客户分类">
                                {{detailData.customer_category}}
                            </c-detail-item>
                            <c-detail-item label="客户级别">
                                {{detailData.customer_level}}
                            </c-detail-item>
                            <c-detail-item label="集团/普通客户">
                                {{detailData.group_or_ordinary}}
                            </c-detail-item>
                            <!--                <c-detail-item label="集团名称">-->
                            <!--                    {{detailData.group_name}}-->
                            <!--                </c-detail-item>-->
                            <c-detail-item label="公司性质">
                                {{detailData.company_nature}}
                            </c-detail-item>
                            <c-detail-item label="行业分类">
                                {{detailData.industry_classify}}
                            </c-detail-item>
                            <c-detail-item label="经营范围" colspan="2">
                                {{detailData.bussiness_scope}}
                            </c-detail-item>
                            <c-detail-item label="所属国家">
                                {{detailData.country}}
                            </c-detail-item>
                            <c-detail-item label="省份">
                                {{detailData.province}}
                            </c-detail-item>
                            <c-detail-item label="城市">
                                {{detailData.city}}
                            </c-detail-item>
                            <c-detail-item label="区县">
                                {{detailData.district}}
                            </c-detail-item>
                            <c-detail-item label="邮政编码">
                                {{detailData.postal_code}}
                            </c-detail-item>
                            <c-detail-item label="客户联系人">
                                {{detailData.customer_contact}}
                            </c-detail-item>
                            <c-detail-item label="传真">
                                {{detailData.fax}}
                            </c-detail-item>
                            <c-detail-item label="税号">
                                {{detailData.tax_id}}
                            </c-detail-item>
                            <c-detail-item label="开票地址">
                                {{detailData.invoice_address}}
                            </c-detail-item>
                            <c-detail-item label="开票电话">
                                {{detailData.invoice_phone}}
                            </c-detail-item>
                            <c-detail-item label="法人">
                                {{detailData.legal_person}}
                            </c-detail-item>
                            <c-detail-item label="企业员工数量">
                                {{detailData.employee_count}}人
                            </c-detail-item>
                            <c-detail-item label="企业年产值">
                                {{detailData.annual_output_value}}
                            </c-detail-item>
                            <c-detail-item label="同行地位">
                                {{detailData.industry_status}}
                            </c-detail-item>
                            <c-detail-item label="发展趋势">
                                {{detailData.development_trend}}
                            </c-detail-item>
                            <c-detail-item label="永利产品占有率">
                                {{detailData.yongli_product_share}}
                            </c-detail-item>
                            <c-detail-item label="历史竞品品牌信息">
                                {{detailData.competitor_brand_info}}
                            </c-detail-item>
                        </c-detail>

                        <c-title>业务信息</c-title>
                        <c-detail column="2">
                            <c-detail-item label="所属公司">
                                {{detailData.belong_company}}
                            </c-detail-item>
                            <c-detail-item label="所属部门">
                                {{detailData.belong_department}}
                            </c-detail-item>
                            <c-detail-item label="业务员名称">
                                {{detailData.salesman_name}}
                            </c-detail-item>
                            <c-detail-item label="业务员电话">
                                {{detailData.salesman_phone}}
                            </c-detail-item>
                        </c-detail>

                        <c-title>记录时间</c-title>
                        <c-detail column="2">
                            <c-detail-item label="创建时间">
                                {{detailData.create_date}}
                            </c-detail-item>
                            <c-detail-item label="修改时间">
                                {{detailData.modify_date}}
                            </c-detail-item>
                            <c-detail-item label="最新同步时间">
                                {{detailData.receive_date}}
                            </c-detail-item>
                        </c-detail>
                    </div>
                </module-tab>
                <module-tab name="客户地址" enable-flex>
                    <m-operate>
                        <c-button color="main" v-if="auth('b_customer_address_edit')" prepend-icon="tf-add"
                                  @click="addCustomerAddress()">添加地址</c-button>
                    </m-operate>
                    <div class="m-detail-box">
                        <c-table ref="customAddressList" border :paging="false">
                            <c-table-column label="地址" width="250">
                                <template #default="{data}">
                                    <span>
                                        {{data.province_name}}
                                        {{data.city_name}}
                                        {{data.county_name}}
                                        {{data.address_detail}}
                                    </span>
                                </template>
                            </c-table-column>

                            <c-table-column label="状态" width="120">
                                <template #default="{data}">
                                    <c-switch v-if="auth('b_customer_address_edit')" v-model="data.enable_status" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="customAddrssStateHandle(arguments[0], arguments[1], data)"></c-switch>
                                    <c-state v-else dict="disableEnableDic" :value="data.enable_status"></c-state>
                                </template>
                            </c-table-column>

                            <c-table-column type="button" label="操作" width="180" button-limit="3">
                                <template #default="{data}">
                                    <c-table-button v-if="auth('b_customer_address_view')" icon="tf-view" @click="globalDialog('customerAddressDetail', {props: {id: data.id}})">查看</c-table-button>
                                    <c-table-button v-if="auth('b_customer_address_edit')" icon="tf-edit" @click="$refs.addressEdit.openForAdd(detailData,data.id)">编辑</c-table-button>
                                    <c-table-button v-if="auth('b_customer_address_edit')" icon="tf-delete" @click="removeAddress(data)">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
            <!--编辑客户地址-->
            <customer-address-edit ref="addressEdit" @resolve="$refs.customAddressList.update()"></customer-address-edit>
        </module>
    </c-dialog>
</template>

<script>
import CustomerAddressEdit from "@/pages/basic/customer_address_edit.vue";

export default {
    name: 'customerDetail',
    components: {CustomerAddressEdit},

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.request({
                url: '/customer/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData =  data;
                    //加载客户地址列表
                    this.loadCustomAddrss();
                    //加载客户列表
                    this.$refs.dialog.open();
                }
            });
        },
        /**
         * 添加客户地址
         * @param data
         */
        addCustomerAddress(id) {
            this.$refs.addressEdit.openForAdd(this.detailData)
        },
        /**
         * 加载客户地址
         */
        loadCustomAddrss() {
            this.$refs.customAddressList.load({
                url: '/customer/address/list',
                data:{
                    customer_id: this.id
                }
            });
        },
        /******启禁用*********/
        customAddrssStateHandle(state, next, data) {
            this.request({
                url: '/customer/address/update_status',
                data: {
                    id: data.id,
                    status: state ? 2 : 1
                },
                success: (data, message) => {
                    this.$message({
                        message: message,  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },
        removeAddress(data) {
            this.$confirm({
                message: '确认删除该客户地址？删除后不可恢复',
                buttonName: '确定删除',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/customer/address/delete',
                        data: { id: data.id },
                        loading: true,
                        success: () => {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.$refs.customAddressList.update();
                        }
                    });
                },
                cancel: () => {},
            });
        },
    }
}
</script>

<style lang="stylus" scoped>

</style>
